module.exports = __webpack_public_path__ + "static/media/special_item63f57616e13a6aff719cb922f5c5dcd3.webp";